/**
 * Bundled global side-menu open SFX (`assets/Sounds/ui-menu-open-swish.mp3`). CC0 Freesound — see `assets/Sounds/THIRD_PARTY.txt`.
 */

import {
  resolveBundledMp3NativeSource,
  resolveBundledMp3UriForWeb,
} from './bundledMp3Module.helper';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const MENU_OPEN_SWISH_MODULE = require('../../../assets/Sounds/ui-menu-open-swish.mp3') as unknown;

export function getNativeMenuOpenSwishSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(MENU_OPEN_SWISH_MODULE);
}

export function getMenuOpenSwishBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(MENU_OPEN_SWISH_MODULE);
}
